<template>
  <div
    v-if="mention.advertising_value"
    class="no-wrap flex"
    :class="{ 'tw:min-h-16.5 tw:w-full': stacked }"
  >
    <div
      class="tw:flex tw:flex-nowrap"
      :class="{ 'tw:flex-col tw:gap-2': stacked }"
    >
      <AdvertisingValueIcon
        :class="{
          'tw:m-0 tw:flex tw:size-6 tw:items-center tw:p-0': stacked,
          'tw:mr-0.5 tw:mt-0.5': !stacked && dense,
          'tw:ml-1.5 tw:mr-2.5 tw:mt-3': !stacked && !dense,
        }"
        :content-class="{
          'tw:size-6 tw:text-xs': stacked,
          'tw:text-sm tw:w-5 tw:h-5': !stacked && dense,
          'tw:size-4.5 tw:text-xs': !stacked && !dense,
        }"
      />

      <div
        :class="{
          'tw:text-sm tw:leading-[1.4]': stacked,
          'tw:text-xxs': !stacked && dense,
          'tw:text-base tw:leading-5': !stacked && !dense,
        }"
      >
        {{ $t("advertising_value_widget.short_label") }}

        <div
          class="tw:text-left tw:font-bold"
          :class="{
            'tw:text-base': stacked,
            'tw:text-xxs': !stacked && dense,
          }"
        >
          {{ compactAdvertisingValueEquivalency }}
        </div>
      </div>
    </div>

    <BaseStreemTooltip v-if="!stacked">
      <div class="q-pa-sm">
        <MetricEditorInfoAlert
          class="q-mb-sm"
          show-ave-multiplier-info
        />
        <div>
          {{
            $t("advertising_value_widget.advertising_value_equivalency", {
              ave: advertisingValueEquivalency,
            })
          }}
        </div>
        <div class="softer smaller q-mt-sm">
          {{ $t("ave_disclaimer", { platformName: appConfig.platformName }) }}
        </div>
      </div>
    </BaseStreemTooltip>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";

import AdvertisingValueIcon from "shared/components/AdvertisingValueIcon.vue";
import { BaseStreemTooltip } from "shared/components/base";
import MetricEditorInfoAlert from "shared/components/user/MetricEditorInfoAlert.vue";
import useCurrency from "shared/composables/useCurrency";
import { suffix } from "shared/helpers/number";
import { useGlobalStore } from "shared/stores/global";

export default {
  name: "AdvertisingValueWidget",
  components: {
    MetricEditorInfoAlert,
    AdvertisingValueIcon,
    BaseStreemTooltip,
  },
  props: {
    mention: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
    },
    stacked: {
      type: Boolean,
    },
  },
  setup() {
    const globalStore = useGlobalStore();

    const { appConfig } = storeToRefs(globalStore);

    const { numberToCurrentUserCurrency } = useCurrency();

    return { appConfig, numberToCurrentUserCurrency };
  },
  computed: {
    compactAdvertisingValueEquivalency() {
      return suffix(this.mention.advertising_value);
    },
    advertisingValueEquivalency() {
      return this.numberToCurrentUserCurrency(this.mention.advertising_value, {
        currencyDisplay: "code",
        codeOnFront: true,
      });
    },
  },
};
</script>
